import { isIOS, isInIframe } from './env';

// On iOS-in-iframe, the pushState/back pattern that powers modal-back-button
// dismissal is unreliable: WebKit's joint-history model can pop the parent
// frame and "exit" the embedded site. Both helpers are skipped together so
// cleanup never lands on a stale half-state (e.g. skipping the push but still
// calling back, which would pop a real entry).
const skip = isIOS && isInIframe;

export function safePushState(state: Record<string, unknown>) {
  if (skip) return;
  window.history.pushState(state, '');
}

export function safeHistoryBack() {
  if (skip) return;
  window.history.back();
}
